import axios from "axios";
import apiConfig from './api-config'

const MovieDB = axios.create({
    baseURL: apiConfig.baseURL,
    headers: { "Content-Type": "application/json" },
    paramsSerializer: (params) => {
        return new URLSearchParams({
            ...params,
            api_key: apiConfig.apiKey,
        });
    },
});

export default MovieDB;
